<div *ngIf="!environment.production" class="alert alert-warning text-center" data-bs-theme="dark" role="alert">
  You are on the test version of this site. Please, click <a href="{{ actualUrl }}">here</a> to go to the actual site.
</div>
